<template>
    <p class="u-extra-small-margin--bottom">
        <strong>Ampelsysteme:</strong>
        <span class="c-ranking c-ranking--none"></span> (keine Bewertung),
        <span class="c-ranking c-ranking--red"></span> (Im Notfall),
        <span class="c-ranking c-ranking--yellow"></span> (Akzeptabel),
        <span class="c-ranking c-ranking--green"></span> (Bevorzugt)
    </p>
</template>
<script>
    export default {
        name: 'RankingLegend'
    }
</script>
